/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopPhaseGridBlock = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorkshopPhaseGridBlock model module.
   * @module model/WorkshopPhaseGridBlock
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopPhaseGridBlock</code>.
   * @alias module:model/WorkshopPhaseGridBlock
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>WorkshopPhaseGridBlock</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopPhaseGridBlock} obj Optional instance to populate.
   * @return {module:model/WorkshopPhaseGridBlock} The populated <code>WorkshopPhaseGridBlock</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('GridX')) {
        obj['GridX'] = ApiClient.convertToType(data['GridX'], 'Integer');
      }
      if (data.hasOwnProperty('GridY')) {
        obj['GridY'] = ApiClient.convertToType(data['GridY'], 'Integer');
      }
      if (data.hasOwnProperty('BackgroundColor')) {
        obj['BackgroundColor'] = ApiClient.convertToType(data['BackgroundColor'], 'String');
      }
      if (data.hasOwnProperty('Visible')) {
        obj['Visible'] = ApiClient.convertToType(data['Visible'], 'Boolean');
      }
      if (data.hasOwnProperty('WidgetID')) {
        obj['WidgetID'] = ApiClient.convertToType(data['WidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} GridX
   * @default 0
   */
  exports.prototype['GridX'] = 0;
  /**
   * @member {Integer} GridY
   * @default 0
   */
  exports.prototype['GridY'] = 0;
  /**
   * @member {String} BackgroundColor
   * @default ''
   */
  exports.prototype['BackgroundColor'] = '';
  /**
   * @member {Boolean} Visible
   * @default false
   */
  exports.prototype['Visible'] = false;
  /**
   * @member {Integer} WidgetID
   * @default 0
   */
  exports.prototype['WidgetID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


